/**
 * Converts a style string from the CMS to separate props to set on a Button component.
 * E.G. "secondary outline" => { theme: secondary, outline: true }
 *
 * This would be better suited to live in the bloomreach package,
 * but we can't add that dependency to common.
 */ function createButtonStyles(linkStyle) {
    const defaultButtonStyles = {
        color: 'primary',
        variant: 'solid'
    };
    const styles = linkStyle && linkStyle.split(' ');
    if (!styles || !styles.length) {
        return defaultButtonStyles;
    }
    return {
        color: styles.includes('secondary') ? 'secondary' : 'primary',
        variant: styles.includes('outline') ? 'outline' : 'solid'
    };
}

export { createButtonStyles };
//# sourceMappingURL=create-button-styles.js.map
